export default {
  methods: {
    searchCollection(data, search, fields, options) {
      if (!Array.isArray(data)) {
        return [];
      }

      const formatValue = (value) => {
        let currentValue = (value || '').toString().toLowerCase();
        if (options?.removeMaskCnpjCpf) {
          currentValue = currentValue.replace(/[-.]/g, '');
        }

        return currentValue;
      };

      const filter = (value) => {
        if (typeof fields === 'string') {
          return formatValue(value[fields]).indexOf(formatValue(search)) > -1;
        }

        return fields.some((field) => formatValue(value[field]).indexOf(formatValue(search)) > -1);
      };

      return data.filter((value) => filter(value));
    },
    descriptionFilter(option, _, search) {
      const temp = search.toLocaleLowerCase();

      return (
        option?.id.toString()?.includes(temp) ||
        option?.descricao?.toLocaleLowerCase().includes(temp) ||
        option?.codigo?.includes(temp) ||
        option?.description?.toLocaleLowerCase().includes(temp) ||
        option?.reference?.toLocaleLowerCase().includes(temp) ||
        option?.code?.includes(temp) ||
        option?.sequence?.toString()?.includes(temp)
      );
    },
    personFilter(option, _, search) {
      const temp = search.toLocaleLowerCase();

      return (
        option?.name?.toLocaleLowerCase().includes(temp) || option?.identification?.includes(temp)
      );
    },
  },
};
